/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const XLineTop = createLucideIcon("x-line-top", [
  ["path", { d: "M18 4H6", key: "1hsngl" }],
  ["path", { d: "M18 8 6 20", key: "xspwia" }],
  ["path", { d: "m6 8 12 12", key: "qb1veh" }]
]);

export { XLineTop as default };
//# sourceMappingURL=x-line-top.js.map
